import React from 'react';
import { CircularProgress } from '@mui/material';
/**
 * LoadingState Component
 * Displays a loading indicator when data is being fetched.
 */
const LoadingState = () => {
    return (
        <div className="d-flex justify-content-center my-4">
            <CircularProgress />
        </div>
    );
};

export default LoadingState;